import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { Input, Button, message, Pagination, notification, Tag, Empty, Tooltip, Popover, Spin } from 'antd';
import { CheckCircleFilled, CheckCircleOutlined, CloseCircleOutlined, DownloadOutlined, FileOutlined, FilePdfOutlined, FileWordOutlined, FilterOutlined, LeftOutlined, SearchOutlined } from '@ant-design/icons';
// import './index.css';
import styles from './index.module.css';
import debounce from 'lodash.debounce';

import apiClient from '../../utils/apiService';

function Email() {

  const navigate = useNavigate();
  // 全局message
  const [messageApi, contextHolder] = message.useMessage();


  const [mailData, setMailData] = useState([]);
  // 邮件原文内容（可编辑）
  const [emailContent, setEmailContent] = useState(null);
  // const [htmlContent, setHtmlContent] = useState('');
  const [selectedMail, setSelectedMail] = useState(null);

  // 查询接口方法
  const fetchData = useCallback(async (toparams) => {
    try {
      // 发送 GET 请求
      await apiClient.get(`/shipping-order/emails-detail?${toparams}`)
        .then((response) => {
          const { data } = response?.data;
          setMailData(data);
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      messageApi.error(error.message || 'Data fetch failed');
    }
  }, []);


  useEffect(() => {
    // 获取url参数
    const { search } = window.location;
    const params = new URLSearchParams(search);
    fetchData(params);
  }, [])


  // 监听selectedMail的变化，如果变化则更新emailContent
  useEffect(() => {
    if (mailData.length > 0) {
      setSelectedMail(mailData[0].email_id);
      setEmailContent(mailData[0]);
    }
  }, [mailData]);


  // 处理邮件项点击事件
  const handleMailClick = (item) => {
    setSelectedMail(item.email_id);
    setEmailContent(item);
  };


  // 下载附件
  const download_attachments = (item) => {
    const link = document.createElement('a');
    link.href = item?.oss_url;
    link.download = item.file_name;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }


  return (
    <div className={styles.mail_container}>
      {contextHolder}

      {
        mailData && mailData.length > 0 ? (
          <>
            <div className={styles.maillist_panel}>
              <div className={styles.maillist_panel_toolbar}>
                <div className={styles.maillist_panel_toolbar_back}>
                  <Button
                    type="dashed"
                    onClick={() => navigate(-1)}
                    // shape='circle'
                    size='small'
                  >
                    <LeftOutlined />
                  </Button>
                </div>
              </div>

              <div className={styles.maillist_panel_list}>
                {mailData.map(item => (
                  <div
                    key={item.email_id} // 使用 email_id 作为唯一标识符
                    className={`${styles.mail_item} ${selectedMail === item.email_id ? styles.selected : ''}`}
                    onClick={() => handleMailClick(item)}
                  >
                    <div className={styles.mail_header}>
                      <span className={styles.mail_header_sender}>
                        {item.from_email}
                      </span>
                    </div>

                    <div className={styles.mail_subject}>
                      {item.subject}
                      <span className={styles.time}>
                        {new Date(item.date).toLocaleString()} {/* 格式化日期 */}
                      </span>
                    </div>
                  </div>
                ))}
              </div>


            </div>


            {/* 右侧展示区域 */}
            <div
              className={styles.mailcontent_panel}
            >
              {/* 上方文本内容 */}
              <div
                className={styles.mailcontent_panel_title}
              >
                <div className={styles.mailcontent_panel_title_item}>
                  <div className={styles.mailcontent_panel_title_item_label}>Sender</div>
                  <Tag className={styles.mailcontent_panel_title_item_tag} color='blue'>{emailContent?.from_email || 'default'}</Tag>
                </div>
                <div className={styles.mailcontent_panel_title_item}>
                  <div className={styles.mailcontent_panel_title_item_label}>Recipient</div>
                  <Popover content={emailContent?.to_email || ''} style={{ width: '50%' }} placement='bottom'>
                    <Tag className={styles.mailcontent_panel_title_item_tag} color='blue'>{emailContent?.to_email || 'default'}</Tag>
                  </Popover>
                </div>
                <div className={styles.mailcontent_panel_title_item}>
                  <div className={styles.mailcontent_panel_title_item_label}>Time</div>
                  <Tag className={styles.mailcontent_panel_title_item_tag} color='blue'>{new Date(emailContent?.date).toLocaleString() || 'default'}</Tag>
                </div>
                <div className={styles.mailcontent_panel_title_item}>
                  <div className={styles.mailcontent_panel_title_item_label}>Subject</div>
                  <Tag className={styles.mailcontent_panel_title_item_tag} color='blue'>{emailContent?.subject || 'default'}</Tag>
                </div>
              </div>

              {/* 下方 HTML 内容 */}
              <div className={styles.mailcontent_panel_content}>
                <div
                  dangerouslySetInnerHTML={{ __html: emailContent?.html_content || emailContent?.content || "No content for now" }}
                ></div>
              </div>

              {/* 附件 */}
              {emailContent?.attachments?.length > 0 && (
                <div className={styles.mailcontent_panel_attachments}>
                  {emailContent?.attachments?.map((item, index) => {
                    // 根据文件类型选择图标
                    const fileType = item.file_name.split('.').pop().toLowerCase();
                    let icon;
                    if (fileType === 'pdf') {
                      icon = <FilePdfOutlined style={{ color: 'red', fontSize: '24px' }} />;
                    } else if (fileType === 'doc' || fileType === 'docx') {
                      icon = <FileWordOutlined style={{ color: 'blue', fontSize: '24px' }} />;
                    } else {
                      icon = <FileOutlined style={{ color: 'purple', fontSize: '24px' }} />;
                    }

                    return (
                      <Tooltip
                        key={index}
                        title={item.file_name}
                      >
                        <div key={index} className={styles.mailcontent_panel_attachments_attachmentContainer_fileItem}>
                          {/* icon */}
                          {icon}

                          {/* size */}
                          <div className={styles.mailcontent_panel_attachments_attachmentContainer_fileItem_fileSize} title={item.size_kb}>
                            {Math.round(item.size_kb)}KB
                          </div>

                          {/* download button */}
                          <DownloadOutlined
                            className={styles.mailcontent_panel_attachments_attachmentContainer_fileItem_downloadButton}
                            onClick={() => {
                              download_attachments(item);
                            }
                            }

                          />

                        </div>
                      </Tooltip>
                    );
                  })}
                </div>
              )}
            </div>

          </>
        ) : (
          // 无数据时的提示
          <div className={styles.emptyEmail}>
            {/* <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description="No Data, Please select the email associated with the workorder"
            /> */}

            {/* 等待数据加载 */}
            <Spin tip="Loading" size="large">
            </Spin>
          </div>
        )




      }
    </div>
  );
}

export default Email;